const fmtPercent = (n) =>
    `${new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 4 }).format(
        Number(n) || 0
    )}٪`;

/**
 * Detect distribution type from level_percents.
 */
const detectDistribution = (percents) => {
    if (!percents || Object.keys(percents).length === 0) return 'نامشخص';

    const values = Object.values(percents).sort(
        (a, b) => Number(b) - Number(a)
    );

    if (values.length === 1) return 'تک‌سطح';

    const first = Number(values[0]);
    const second = Number(values[1]);

    if (first === 0) return 'نامشخص';

    const ratio = second / first;

    if (Math.abs(ratio - 0.5) < 0.05) return 'نصف‌شونده';
    if (Math.abs(ratio - 1) < 0.05) return 'خطی';

    return 'نزولی تدریجی';
};

export default function ConfigTable({
                                        configs,
                                        onEdit,
                                        onActivate,
                                        onDelete,
                                        loading,
                                    }) {
    if (!configs || configs.length === 0) {
        return <div className="empty-state">هنوز تنظیماتی ثبت نشده است.</div>;
    }

    return (
        <div className="table-wrap">
            <table className="configs-table">
                <thead>
                <tr>
                    <th>نام</th>
                    <th>نوع توزیع</th>
                    <th>عمق</th>
                    <th>سقف کل</th>
                    <th>حداقل سود</th>
                    <th>وضعیت</th>
                    <th>عملیات</th>
                </tr>
                </thead>
                <tbody>
                {configs.map((c) => (
                    <tr key={c.id} className={c.is_active ? 'active-row' : ''}>
                        <td>
                            <div className="cell-stack">
                                <strong>{c.name}</strong>
                                {c.description && (
                                    <span className="cell-secondary">{c.description}</span>
                                )}
                            </div>
                        </td>
                        <td>
                <span className="distribution-badge">
                  {detectDistribution(c.level_percents)}
                </span>
                        </td>
                        <td>{c.max_depth}</td>
                        <td>{fmtPercent(c.max_total_percent)}</td>
                        <td>{fmtPercent(c.min_margin_percent)}</td>
                        <td>
                <span
                    className={`status-badge ${
                        c.is_active ? 'status-paid' : 'status-cancelled'
                    }`}
                >
                  {c.is_active ? 'فعال' : 'غیرفعال'}
                </span>
                        </td>
                        <td>
                            <div className="row-actions">
                                <button
                                    className="btn-sm btn-sm-success"
                                    onClick={() => onEdit(c)}
                                    disabled={loading}
                                    title="ویرایش"
                                >
                                    ویرایش
                                </button>
                                {!c.is_active && (
                                    <button
                                        className="btn-sm btn-sm-primary"
                                        onClick={() => onActivate(c.id)}
                                        disabled={loading}
                                        title="فعال‌سازی"
                                    >
                                        فعال‌سازی
                                    </button>
                                )}
                                {!c.is_active && (
                                    <button
                                        className="btn-sm btn-sm-danger"
                                        onClick={() => onDelete(c.id)}
                                        disabled={loading}
                                        title="حذف"
                                    >
                                        حذف
                                    </button>
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}